// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2tDZH","fileBtn":"File_fileBtn__3qi6g","closeBtn":"File_closeBtn__3OKpI","fileSelected":"File_fileSelected__pRabq","disabled":"File_disabled__3CVIH"};